import createHttpError from 'http-errors';

export const parseResponse = async <T>(response: Response): Promise<T> => {
  const { status } = response;

  if (!response.ok) {
    const text = await response.text();

    let error: { message: string; error: string } | undefined;
    try {
      error = JSON.parse(text);
    } catch {
      throw createHttpError(status, text || status.toString());
    }

    throw createHttpError(status, error?.message || error?.error || `Invalid error response ${error}`);
  }

  const data = await response.json();

  if (data.status === 'error' && data.message) {
    throw createHttpError(400, data.message);
  }

  return data as T;
};
